import { render, staticRenderFns } from "./ConfederationHall.vue?vue&type=template&id=77cd3304&"
import script from "./ConfederationHall.vue?vue&type=script&lang=js&"
export * from "./ConfederationHall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports